module.exports = __webpack_public_path__ + "static/img/anli9.94c0d08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anli/anli9.jpg
// module id = ufnp
// module chunks = 1